module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEYAAABHCAMAAACNrMETAAAASFBMVEUAAAD8yAAAAAAeGADUqADntwApIABSQQAjGwALCQDEmwDfsQDInwAOCwDywADgsgDhsgBcSQA+MQDSpwB5YAA1KgAXEgAVEQAQMjJdAAAAAXRSTlMAQObYZgAAAKBJREFUWMPt1UsOwjAQBFE8EAjgGBJ+978py9oAstxZEKXrAE9yy9JsZirNkhkzZsyYWQ3T7Z9dO4MSfREYlIv0KJR2BuUsTYyiMCgKg6IwrNvOoFyTwqA0MyivvPvcrVQzU/xoqmbGiKHffulev80hhpyEbXCOJ43B0RgcjcHRGByNwdEYHInByRrDP5QYHOFO0fgo/3N8zZgxY8bMYpg30xIW6bmXSLgAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/toLeftIcon.png
// module id = OFBk
// module chunks = 2